import React from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';

const SelectBankModal = (props) => {
  const { show, onClose, bankList } = props;

  return (
    <Modal size="sm" show={show} centered onHide={onClose}>
      <Col>
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            Выберите банк для оплаты
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-grid gap-2">
            {bankList.map((bank) => (
              <Button
                key={bank.name}
                variant="light"
                className="d-flex align-items-center gap-2"
                onClick={() => window.open(bank.link, '_blank')}
              >
                <Image src={bank.logo} alt={bank.name} width={24} height={24} rounded />
                {bank.name}
              </Button>
            ))}
          </div>
        </Modal.Body>
      </Col>
    </Modal>
  );
};

export default SelectBankModal;
